export default __webpack_public_path__ + "static/media/svg-4.e9c0a596.svg";